import MainClass, { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

class TextWithImage extends MainClass {
	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.selector && this.init();
	}

	initAnimation = () => {
        const label = this.selector.querySelector('.text-and-image-label') as HTMLElement;
		const heading = this.selector.querySelector( '.text-and-image-heading' ) as HTMLElement;
		const description = this.selector.querySelector( '.raise-who-we-are-description-wrapper' ) as HTMLElement;
		const button = this.selector.querySelector('.raise-who-we-are-text-wrapper a') as HTMLElement;
		const imageBlock = this.selector.querySelector( '.raise-who-we-are-image-wrapper' ) as HTMLElement;
		gsap.registerPlugin( ScrollTrigger );

		let tl = gsap.timeline( {
			scrollTrigger: {
				trigger: this.selector,
				start: 'top +=50%',
				end: 'top +=30%',
			},
		} );

		if (label) {
			tl.fromTo(
				label,
				{
					opacity: 0,
					y: '50%',
				},
				{
					opacity: 1,
					y: 0,
					duration: 0.4,
				},
				'start',
			);
		}
		
		if (heading) {
			tl.fromTo(
				heading,
				{
					opacity: 0,
					y: '50%',
				},
				{
					opacity: 1,
					y: 0,
					duration: 0.4,
				},
				'start',
			);
		}

		if (description) {
			tl.fromTo(
				description,
				{
					opacity: 0,
					y: '50%',
				},
				{
					opacity: 1,
					y: 0,
					duration: 0.4,
				},
				'start',
			);
		}

		if (button) {
			tl.fromTo(
				button,
				{
					opacity: 0,
					y: '50%',
				},
				{
					opacity: 1,
					y: 0,
					duration: 0.4,
				},
				'start',
			);
		}

		if (imageBlock) {
			tl.fromTo(
				imageBlock,
				{
					opacity: 0,
					y: '70%',
				},
				{
					opacity: 1,
					y: 0,
					duration: 0.4,
				},
				'start',
			);
		}
	};

	init() {
		this.initAnimation()
	}
}

export default TextWithImage;
